export function useApplicationForm() {
  function confirmUploadSize(form, uploadInputRef) {
    const upload = form.querySelector(`#${uploadInputRef}`);
    const errorMsg = `<span class="error-message">File is too large. Please upload file under 1mb</span>`;

    form.addEventListener("submit", (e) => {
      if (upload.files[0].size > 1000000) {
        e.preventDefault();
        upload.insertAdjacentHTML("afterend", errorMsg);
      }
    });
  }

  const applicationForm = document.querySelector("#application-form");

  applicationForm && confirmUploadSize(applicationForm, "applicant-resume");
}
